// Reusable debounce utility — add once at the top of custom.js:
function debounce(fn, delay = 150) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

/* Tab Start */
function InitTabs() {
  document.querySelectorAll(".Tabs_common_main_new").forEach(container => {

        const tabs = container.querySelectorAll(".Tabs_common_inner_new");
        const contents = container.querySelectorAll(".tabcontent");

        const group = container.querySelector("[data-tab-group]");
        const bg = group ? group.querySelector(".tab_background_new") : null;

        function moveBgToTab(tab) {
            if (!group || !bg) return;

            const tabsArr = Array.from(tabs);
            const isLast = tab === tabsArr[tabsArr.length - 1];

            const tabRect = tab.getBoundingClientRect();
            const groupRect = group.getBoundingClientRect();

            let offset = tabRect.left - groupRect.left;

            // 3px gap on last tab
            if (isLast) offset -= 0;

            bg.style.width = `${tabRect.width}px`;
            bg.style.transform = `translateX(${offset}px)`;
        }

        function activateTab(tab) {
          const tabId = tab.getAttribute("tab_id");
          if (!tabId) return;

          tabs.forEach(t => t.classList.remove("active"));
          contents.forEach(c => c.style.display = "none");
          contents.forEach(c => c.classList.remove("active"));

          tab.classList.add("active");

          const targets = container.querySelectorAll(`.${tabId}_open`);
          targets.forEach(t => t.style.display = "block");
          targets.forEach(t => t.classList.add("active"));

          moveBgToTab(tab);
        }

        // 🔥 Recalculate background position on screen resize
        function updateActiveTabBg() {
            const activeTab = container.querySelector(".Tabs_common_inner_new.active");
            if (activeTab) moveBgToTab(activeTab);
        }
        window.addEventListener("resize", debounce(updateActiveTabBg, 150));

        tabs.forEach(tab => {
            tab.addEventListener("click", () => activateTab(tab));
        });

        const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
        if (firstActive) activateTab(firstActive);

        const navMenu = document.querySelector(".menu-list__list-item");

        if(navMenu){
          navMenu.addEventListener("mouseenter", () => {
              const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
              if (firstActive) activateTab(firstActive);
          });
        }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  InitTabs();
});
document.addEventListener("shopify:section:load", () => {
  InitTabs();
});
/* Tab End */

/* Accordian Start */
function initCustomAccordion(root) {
    const scope = root || document;
    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            question.setAttribute("role", "button");
            question.setAttribute("tabindex", "0");
            question.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");

            // Ensure correct default state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
                answer.style.height = "auto";
            } else {
                answer.style.display = "none";
                answer.style.height = 0;
            }

            // Drop any end-of-animation callback still pending on a panel, so a
            // stale timer can never write styles after the state changed again
            const cancelPending = (el) => {
                if (el.accordionTimer) {
                    clearTimeout(el.accordionTimer);
                    el.accordionTimer = null;
                }
            };

            // Collapse from whatever height the panel is rendering at right now,
            // so interrupting a half-open panel reverses smoothly instead of jumping
            const collapse = (el) => {
                cancelPending(el);
                const startHeight = el.getBoundingClientRect().height;
                el.style.display = "block";
                el.style.transition = "none";
                el.style.height = startHeight + "px";
                void el.offsetHeight;                      // flush the start height
                el.style.transition = "height 300ms ease";
                el.style.height = "0px";
                el.accordionTimer = setTimeout(() => {
                    el.accordionTimer = null;
                    el.style.display = "none";
                    el.style.removeProperty("transition");
                }, 300);
            };

            // Expand from the current height for the same reason
            const expand = (el) => {
                cancelPending(el);
                const startHeight = el.getBoundingClientRect().height;
                el.style.display = "block";
                el.style.transition = "none";
                el.style.height = "auto";                  // get natural height
                const endHeight = el.scrollHeight;
                el.style.height = startHeight + "px";      // restart animation
                void el.offsetHeight;
                el.style.transition = "height 300ms ease";
                el.style.height = endHeight + "px";
                el.accordionTimer = setTimeout(() => {
                    el.accordionTimer = null;
                    el.style.height = "auto";
                    el.style.removeProperty("transition");
                }, 300);
            };

            const toggleItem = () => {
                const isOpen = item.classList.contains("open");

                // A pending scroll belongs to the previous click, not this one
                if (item.accordionScrollTimer) {
                    clearTimeout(item.accordionScrollTimer);
                    item.accordionScrollTimer = null;
                }

                // Close all other items
                items.forEach(i => {
                    if (i === item) return;
                    if (!i.classList.contains("open")) return; // nothing to animate
                    i.classList.remove("open");
                    const iQuestion = i.querySelector(".question");
                    if (iQuestion) iQuestion.setAttribute("aria-expanded", "false");
                    const a = i.querySelector(".answer");
                    if (a) collapse(a);
                });

                // If the clicked one was open, just close it
                if (isOpen) {
                    item.classList.remove("open");
                    question.setAttribute("aria-expanded", "false");
                    collapse(answer);
                    return;
                }

                // Otherwise, open it
                item.classList.add("open");
                question.setAttribute("aria-expanded", "true");
                expand(answer);

                // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
                const container = item.closest(".Product_meta_collapsible_main_new");
                if (container) {
                    // Scroll to question AFTER opening
                    item.accordionScrollTimer = setTimeout(() => {
                        item.accordionScrollTimer = null;
                        const offset = 100; // adjust to your header height
                        const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                        window.scrollTo({
                            top: y,
                            behavior: "smooth"
                        });
                    }, 300);
                }
            };

            question.addEventListener("click", toggleItem);
            question.addEventListener("keydown", (event) => {
                if (event.key !== "Enter" && event.key !== " ") return;
                event.preventDefault();
                toggleItem();
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */

/* Video Lazy Load */
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      const shouldLoad =
        (video.classList.contains("video--mobile") && isMobile()) ||
        (video.classList.contains("video--desktop") && !isMobile());

      if (!shouldLoad) return;

      // 🔹 PRELOAD when close (even if not visible yet)
      if (entry.intersectionRatio > 0 && !video.dataset.loaded) {
        video.src = video.dataset.src;
        video.preload = "auto";
        video.load();
        video.dataset.loaded = "true";
      }

      // 🔹 PLAY only when visible
      if (entry.isIntersecting) {
        if (video.readyState >= 2) {
          video.play().catch(() => {});
        } else {
          video.addEventListener(
            "loadeddata",
            () => video.play().catch(() => {}),
            { once: true }
          );
        }
      } else {
        // Optional pause
        // video.pause();
      }
    });
  }, {
    threshold: [0, 0.25],
    rootMargin: "400px 0px" // VERY IMPORTANT
  });

  videos.forEach(video => observer.observe(video));
});
/* Video Lazy Load */

/* Scrollbar */
document.querySelectorAll('.simplebar').forEach(el => {
    if (el.dataset.simplebarInitialized) return;

    new SimpleBar(el, {
        autoHide: false
    });

    el.dataset.simplebarInitialized = 'true';
});
/* Scrollbar */

/* Product Page */
function productPageScript(){
  /* Gallery Slider Tile */
  const gallerySliderTiles = document.querySelectorAll('.pdp-gallery-tile__slider');
  if (gallerySliderTiles.length) {
    gallerySliderTiles.forEach((el) => {
      if (el.classList.contains('swiper-initialized')) return;

      new Swiper(el, {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        speed: 300,
        pagination: {
          el: '.pdp-gallery-tile__pagination',
          clickable: true,
        },
      });
    });
  }
  /* Gallery Slider Tile */

  /* Retailer Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pdp-retailers__drawer-open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll('.pdp-retailers-drawer__body.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.pdp-retailers-drawer__body.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('pdp-retailers-drawer__is-open');
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.pdp-retailers-drawer__overlay, .pdp-retailers__drawer-close');
    if (!closeTrigger) return;

    document.body.classList.remove('pdp-retailers-drawer__is-open');

    document.querySelectorAll('.pdp-retailers-drawer__body.open')
      .forEach(el => el.classList.remove('open'));
  });
  /* Retailer Drawer */
  
  /* Nutrition Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pdp-nutrition__drawer-open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll('.pdp-nutrition-drawer__body.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.pdp-nutrition-drawer__body.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('pdp-nutrition-drawer__is-open');
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.pdp-nutrition-drawer__overlay, .pdp-nutrition__drawer-close');
    if (!closeTrigger) return;

    document.body.classList.remove('pdp-nutrition-drawer__is-open');

    document.querySelectorAll('.pdp-nutrition-drawer__body.open')
      .forEach(el => el.classList.remove('open'));
  });
  /* Nutrition Drawer */

  /* Gallery Preview Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pdp-gallery-preview__drawer-open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    document.querySelectorAll('.pdp-gallery-preview-drawer__body.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.pdp-gallery-preview-drawer__body.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('pdp-gallery-preview-drawer__is-open');
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.pdp-gallery-preview-drawer__overlay, .pdp-gallery-preview__drawer-close');
    if (!closeTrigger) return;

    document.body.classList.remove('pdp-gallery-preview-drawer__is-open');

    document.querySelectorAll('.pdp-gallery-preview-drawer__body.open')
      .forEach(el => el.classList.remove('open'));
  });
  /* Gallery Preview Drawer */

  /* product-main-custom-logo-marquee */
  initMarquee('.product-main-custom-logo-marquee', {
      mobile: {
          duration: 60000,
          gap: 0,
          duplicated: true,
          direction: "left"
      },
      desktop: {
          duration: 70000,
          gap: 0,
          duplicated: true,
          direction: "left"
      }
  });
  /* product-main-custom-logo-marquee */
}

if (document.body.classList.contains('template-product')) {
    productPageScript();
}
/* Product Page */



/*
document.querySelectorAll('.Index_object_testimonial_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 24,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
            0: {
                freeMode: false,
                spaceBetween: 16
            },
            750: {
                spaceBetween: 24
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});
*/
